<template>
  <div
    v-bind:id="datos.titulo"
    class="bloqueUnoServicios__cajaImagenes"
    v-on:click="expandir(datos.titulo)"
  >
    <p v-if="!dispositivo && desplegado" class="cerrar">X</p>
    <h2
      v-bind:id="datos.titulo + '-titulo'"
      class="bloqueUnoServicios__cajaImagenes--titulo"
    >
      <strong>{{ datos.titulo }}</strong>
    </h2>

    <img
      class="flecha-abajo"
      v-if="!dispositivo && desplegado"
      src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-servicios/Recurso+26.svg"
      alt=""
    />

    <div class="imgCaja clicable">
      <img
        v-bind:src="[dispositivo ? datos.url_img.movil : datos.url_img.pc]"
        alt=""
      />
    </div>
  </div>
  <!-- interior oculto de cada caja -->
  <div v-bind:id="datos.titulo + '-content'" class="cajaImagenes-contenido">
    <h2 class="cajaImagenes-contenido__titulo" id="content">
      {{ datos.subtitulo.cabecera.es }}
    </h2>
    <p
      v-for="item in datos.subtitulo.descripcion.es"
      :key="item"
      class="cajaImagenes-contenido__texto"
    >
      {{ item }}
    </p>
    <div class="carousel-container">
      <div class="carousel">
        <div v-bind:class="['slider-' + datos.titulo]" class="slider">
          <div
            v-for="(item, index) in datos.slider.elementos"
            :key="item"
            class="cajaImagenes-slider"
            v-bind:id="[index]"
          >
            <picture>
              <img
                class="cajaImagenes-slider__imagen"
                v-bind:src="[
                  dispositivo ? item.url_img.movil : item.url_img.pc,
                ]"
                alt=""
              />
            </picture>
            <div class="cajaImagenes-slider__textos">
              <p class="cajaImagenes-slider__sobre-titulo" v-if="!dispositivo">
                ¿Cómo lo hacemos?
              </p>
              <h4 class="cajaImagenes-slider__titulo">
                {{ item.encabezado.es }}
              </h4>
              <p class="cajaImagenes-slider__texto">
                {{ item.descripcion.es }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="cajaImagenes-slider-contador__numeracion">
        <div
          v-bind:id="['numero-' + datos.titulo]"
          class="cajaImagenes-slider-contador__numero"
        >
          <p
            v-bind:class="['numero-' + datos.titulo]"
            style="transition: 0.5s ease all"
            v-for="(item, index) in numeroElementos"
            :key="item"
          >
            0{{ index + 1 }}
          </p>
        </div>
        <button
          v-on:click="animateSlider(datos.titulo)"
          class="cajaImagenes-slider-contador__flecha"
        >
          <img
            v-if="numeroElementos > 1"
            src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-servicios/Recurso+26.svg"
            alt=""
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bloqueUnoPrincipal",

  mounted() {},

  props: {
    datosBloques: Object,
  },

  setup(props) {
    const datos = props.datosBloques;
    const numeroElementos = props.datosBloques.slider.elementos.length;
    return { datos, numeroElementos };
  },

  data() {
    return {
      activo: false,
      posicionActual: 1,
      dispositivo: window.innerWidth < window.innerHeight,
      desplegado: false,
      contador: 1,
    };
  },

  methods: {
    //EVENTO QUE AMPLIA LA CAJA Y MUESTRA SU INFORMACION EN FUNCION DE LA SELECCIONADA
    expandir(datos) {
      // Declaracion de variables
      this.activo = !this.activo;
      let titulo = document.getElementById(datos + "-titulo");
      let bloques = document.querySelectorAll(
        ".bloqueUnoServicios__cajaImagenes"
      );
      let interior_bloque = document.querySelectorAll(
        ".cajaImagenes-contenido"
      );
      let bloqueSeleccionado = document.getElementById(datos);
      let bloqueSliderSeleccionado = document.getElementById(
        datos + "-content"
      );
      let noSeleccionados = [];
      //condicion que discrimina los bloques no seleccionados
      bloques.forEach((item) => {
        if (item.id != bloqueSeleccionado.id) {
          noSeleccionados.push(item); //se almacenan en array
        }
      });
      //eventos
      if (this.activo) {
        this.desplegado = true;
        this.dispositivo
          ? (bloqueSeleccionado.style.height = "100vh")
          : (bloqueSeleccionado.style.width = "100vw"); //Amplia el bloque
        noSeleccionados.forEach((item) => {
          //Oculta los bloques No seleccioandos
          this.dispositivo
            ? (item.style.height = "0vw")
            : (item.style.width = "0vw");
          setTimeout(() => {
            item.style.display = "none";
            bloqueSliderSeleccionado.style.display = "block";
            titulo.classList.add("titulo-desplegado");
          }, 450);
        });
      } else {
        //Se vuelve a hacer click en el bloque para cerrarlo
        this.desplegado = false;
        this.dispositivo
          ? (bloqueSeleccionado.style.height = "40vw")
          : (bloqueSeleccionado.style.width = "33.3vw"); //Amplia el bloque //Vuelve a su tamanio original
        bloqueSliderSeleccionado.style.display = "none";
        titulo.classList.remove("titulo-desplegado");
        noSeleccionados.forEach((item) => {
          //Restaura los bloques ocultos
          item.style.display = "block";
          this.dispositivo
            ? (item.style.height = "40vw")
            : (item.style.width = "33.3vw");
        });
        interior_bloque.forEach((item) => {
          item.style.display = "none"; //Se ocultan los sub-bloques
        });
      }
    },

    animateSlider(data) {
      const slider = document.querySelector(".slider-" + data);
      const maxNumer = 100 / slider.childElementCount;
      const numberContainer = document.getElementById("numero-" + data);

      if (slider.childElementCount > 1) {
        slider.style.transform = `translate(-${maxNumer * this.contador}%)`;
        numberContainer.appendChild(numberContainer.firstElementChild);
        this.contador++;
        if (this.contador >= slider.childElementCount + 1) {
          this.contador = 1;
          slider.style.transform = `translate(0%)`;
        }
      }
    },
  },
};
</script>